/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { BackTop, Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

const initial = {
    vendorTransferPersonalDataId: null,
    vendorDisclosureTitleTh: 'การเปิดเผยข้อมูลส่วนบุคคลของคู่ค้า',
    vendorDisclosureTitleEn: 'Disclosure personal data of Partners',
    vendorDisclosureContentTh: '',
    vendorDisclosureContentEn: '',
    vendorDisclosureIsDisplay: true,
    vendorInternationalTitleTh: 'การส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ',
    vendorInternationalTitleEn: 'International transfers of Personal Data',
    vendorInternationalContentTh: '',
    vendorInternationalContentEn: '',
    vendorInternationalIsDisplay: true,
};

export default function Step5(props) {
    const { setStep5, editData } = props;
    const { form } = props;
    const { t } = useTranslation(['hr-policy']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep5(true);
            })
            .catch(() => setStep5(false));
        props.nextStep();
    };
    const onPreviousStep = () => {
        props.previousStep();
    };
    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'vendorDisclosureTitleTh',
                'vendorDisclosureTitleEn',
                'vendorDisclosureContentTh',
                'vendorInternationalTitleTh',
                'vendorInternationalTitleEn',
                'vendorInternationalContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.vendorTransferPersonalData
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep5(check);
        }
    }, [editData]);
    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-xl">
                {t('Who we will disclose or transfer personal data')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'vendorDisclosureTitleTh',
                        'vendorDisclosureTitleEn',
                        'vendorDisclosureContentTh',
                        'vendorInternationalTitleTh',
                        'vendorInternationalTitleEn',
                        'vendorInternationalContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep5(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Disclosure personal data of Partners')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorDisclosureTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`ในกรณีที่จำเป็น บริษัทอาจต้องเปิดเผยและ/หรือส่งต่อข้อมูลส่วนบุคคลของคู่ค้าให้แก่บุคคลภายนอก ได้แก่\n\n(1) เปิดเผยให้แก่ลูกค้า หรือคู่ค้าอื่น ๆ ของบริษัท ซึ่งบริษัทมีความจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของคู่ค้าเพื่อการปฏิบัติหน้าที่ และการให้บริการแก่ลูกค้าหรือคู่ค้าดังกล่าว รวมถึง ผู้ให้บริการภายนอกของบริษัท รวมถึงแต่ไม่จำกัดเพียง บริษัทในเครือ บริษัทที่ปรึกษา หรือบริษัทตรวจสอบบัญชี เป็นต้น ที่ได้รับการว่าจ้างจากบริษัทให้ช่วยเหลือสนับสนุนการปฏิบัติหน้าที่ของบริษัท โดยเฉพาะส่วนที่เกี่ยวข้องกับการงานที่จัดซื้อจัดจ้างคู่ค้า โดยบริษัทจะดำเนินการดังกล่าว บนหลักการเท่าที่จำเป็น ภายใต้กรอบข้อตกลงสัญญาการประมวลผลข้อมูลส่วนบุคคลระหว่างบริษัทและบุคคลภายนอกดังกล่าวเท่านั้น และ\n\n(2) เปิดเผยตามหน้าที่ที่บริษัทมีตามกฎหมายที่เกี่ยวข้องให้แก่หน่วยงานราชการ หรือเป็นการเปิดเผยกรณีที่บริษัท อยู่ภายใต้บังคับคำพิพากษาหรือตามคำสั่งของหน่วยงานราชการให้เปิดเผยข้อมูลดังกล่าวโดยบริษัทจะดำเนินการเพียงเท่าที่จำเป็นตามหน้าที่เท่านั้น`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorDisclosureContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorDisclosureTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`In cases where necessary, the company may need to disclose and/or transfer personal data of business partners to external parties, including:\n\n(1) Disclosing to customers or other business partners of the company: The company may need to disclose personal data of business partners to fulfill its duties and provide services to customers or said business partners. This includes external service providers engaged by the company, such as subsidiaries, consulting firms, or auditing companies, who have been contracted by the company to assist and support its operations, particularly those related to procurement and contracting with business partners. The company will only proceed with such actions on a necessary basis and within the framework of the contractual agreement for personal data processing between the company and the respective external party.\n\n(2) Disclosing as required by relevant laws and regulations to government agencies: The company may disclose personal data as required by its legal obligations to government agencies, or in cases where the company is subject to court orders or directives from government agencies to disclose such information. The company will only proceed with such actions to the extent necessary and in accordance with its obligations.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorDisclosureContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('International transfers of Personal Data')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorInternationalTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`1.บริษัทอาจส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลอื่นทั้งในประเทศและต่างประเทศในกรณีที่จำเป็นเพื่อปฏิบัติตามสัญญาที่ท่านเป็นคู่สัญญา หรือเป็นการกระทำตามสัญญาระหว่างบริษัทกับบุคคลหรือนิติบุคคลอื่นเพื่อประโยชน์ของท่าน หรือเพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญา หรือเพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของท่านหรือบุคคลอื่น เพื่อปฏิบัติตามกฎหมายหรือเป็นการจำเป็นเพื่อดำเนินภารกิจเพื่อประโยชน์สาธารณะที่สำคัญ\n\n2. บริษัทอาจเก็บข้อมูลของท่านบนคอมพิวเตอร์ เซิร์ฟเวอร์ (Server) หรือคลาวด์ (Cloud) ที่ให้บริการโดยบุคคลอื่น และอาจใช้โปรแกรมหรือแอปพลิเคชันของบุคคลอื่นในรูปแบบของการให้บริการซอฟท์แวร์สำเร็จรูปและรูปแบบของการให้บริการแพลตฟอร์มสำเร็จรูปในการประมวลผลข้อมูลส่วนบุคคลของท่าน ทั้งนี้ บริษัทจะไม่อนุญาตให้บุคคลที่ไม่เกี่ยวข้องสามารถเข้าถึงข้อมูลส่วนบุคคลได้ และบริษัทจะกำหนดให้บุคคลอื่นเหล่านั้นต้องมีมาตรการคุ้มครองความมั่นคงปลอดภัยด้านข้อมูลส่วนบุคคลที่เหมาะสม\n\n3.กรณีที่มีเหตุจำเป็นต้องส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ บริษัทจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลและใช้มาตรการที่เหมาะสมเพื่อให้มั่นใจได้ว่าข้อมูลส่วนบุคคลของท่านจะได้รับความคุ้มครองและท่านสามารถใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่านได้ตามที่กฎหมายกำหนด รวมถึงบริษัทจะกำหนดให้ผู้ที่ได้รับข้อมูลส่วนบุคคลของท่านมีมาตรการปกป้องข้อมูลของท่านอย่างเหมาะสม และประมวลผลข้อมูลส่วนบุคคลดังกล่าวเท่าที่จำเป็นเท่านั้น และดำเนินการเพื่อป้องกันไม่ให้บุคคลอื่นใช้หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจโดยมิชอบ`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorInternationalContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorInternationalTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`1. The Company may transmit or transfer Personal Data to both domestic and international third parties when necessary to perform its contractual obligations that you are a party, or to perform contractual obligations between the company and other persons or other entities for your benefits, or to perform any requests prior to entering a contract, or in order to prevent or deter any danger to your life, body or health or other persons, or to comply with applicable laws and to carry out responsibilities regarding public interest.\n\n2. The Company may collect your Personal Data from computers, servers, cloud storage, or file sharing services provided by a third party. The Company may also use third-party applications such as software or platform services for processing your Personal Data. The Company shall not allow any unauthorized, independent, or non-related parties to access this Personal Data. The Company shall require such third parties who do have permission to access this Personal Data to have appropriate measures for data security.\n\n3.In the event that it is necessary to transmit or transfer your Personal Data overseas, the Company shall comply with applicable personal data protection laws and implement appropriate measures to ensure that your Personal Data is duly protected and shall be able to exercise your rights related to your Personal Data as permitted by law. In addition, the Company shall require these overseas parties to take appropriate measures for data security. The Company shall also take necessary steps to prevent unauthorized use or disclosure of Personal Data.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorInternationalContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex gap-2 items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
